// extracted by mini-css-extract-plugin
export default {"mCard":"OC-z","image":"PC-z","imageNoBackground":"QC-z","imageHasCategory":"RC-z","fullWidth":"SC-z"};